import $ from 'jquery';

export default class FAQ {
    constructor(qaa) {
        this.$qaa = $(qaa);
        this.$q = this.$qaa.find('.faq__q-q');
        this.$a = this.$qaa.find('.faq__q-a');
        if (this.$q.length && this.$a.length) this.init();
    }

    init() {
        this.$q.on('click', () => {
            this.$q.toggleClass('active');
            if (this.$q.hasClass('active')) {
                $('.faq__q-q').removeClass('active');
                $('.faq__q-a').removeAttr('style');
                this.$q.addClass('active');
                this.$a.css('height', this.$a[0].scrollHeight + 'px');
            } else {
                this.$a.removeAttr('style');
            }
        });
    }
}